import { URL_OFFICE_ADMISSION } from "utils/ConstantsAndNum";
import ImgView from "assets/img/viewer.svg";
import { Icon } from "@utp/react-components-prod";

const NotAssigned = () => {
  return (
    <div
      className="bg-02 flex items-center justify-center flex-col"
      data-testid="not-assigned-page"
    >
      <img src={ImgView} alt="Imagen de espectador" />
      <div className="mt-8">
        <h1 className="text-center text-neutral-03 text-heading-02 font-black">
          Aún no te hemos asignado tu examen de admisión
        </h1>
        <p className="text-center text-color-01 leading-snug mt-6">
          Contáctate con tu asesor educativo o envía tu solicitud a la{" "}
          <a
            className="text-color-primary font-bold underline"
            href={URL_OFFICE_ADMISSION}
          >
            Oficina de Admisión
            <Icon
              iconName="external-link"
              className="text-color-primary ml-1"
              size={16}
            />
          </a>{" "}
          <br /> e incluye la información y evidencia relevante.
        </p>
      </div>
    </div>
  );
};

export default NotAssigned;
